import React from "react";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTrigger,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TicketCard } from "@/pages/orders/components/ticket";
import { ITicketToAssign } from "@/pages/orders/schemas/ticket-to-assign";
import UrlInput from "@/components/fields/url-input";

export interface IGenericTicketAssignmentProps {
  order: any;
  setTickets: any;
}

export function GenericTicketAssignment({
  order,
  setTickets,
}: IGenericTicketAssignmentProps) {
  const [ticketsToAssign, setTicketsToAssign] = React.useState<
    Partial<ITicketToAssign>[]
  >([]);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const requestedTickets: {
      id: string;
      name: string;
      price: number;
      quantity: number;
    }[] = order.params.products;
    const acc: Partial<ITicketToAssign>[] = [];

    requestedTickets.forEach((t) => {
      for (let i = 0; i < t.quantity; i++) {
        acc.push({
          id: `${t.id}-${i}`,
          name: t.name,
          type: t.name,
          price: t.price,
        });
      }
    });

    setTicketsToAssign(acc);
  }, [order]);

  return (
    <div className="flex flex-col gap-1">
      {ticketsToAssign.map((t, idx) => {
        return (
          <TicketCard key={idx} idx={idx} order={order} ticket={t}>
            <Dialog open={open} onOpenChange={setOpen}>
              <DialogTrigger asChild>
                <Button variant="secondary">Assign Ticket</Button>
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-svh overflow-auto">
                <DialogHeader>
                  <DialogTitle>Manually assign ticket info</DialogTitle>
                  <DialogDescription>
                    Find the ticket urls from the provider and paste them here
                  </DialogDescription>
                </DialogHeader>
                <Label>URL</Label>
                <UrlInput
                  value={t.url}
                  placeholder="Ticket Url"
                  onBlur={(e) =>
                    setTicketsToAssign((prev) => {
                      prev[idx].url = e.target.value;
                      return prev;
                    })
                  }
                />
                <Label>Apple Wallet URL</Label>
                <UrlInput
                  value={t.appleWalletUrl}
                  placeholder="Apple Wallet Url"
                  onBlur={(e) => {
                    setTicketsToAssign((prev) => {
                      prev[idx].appleWalletUrl = e.target.value;
                      return prev;
                    });
                  }}
                />
                <Label>Google Wallet URL</Label>
                <UrlInput
                  value={t.googleWalletUrl}
                  placeholder="Google Wallet Url"
                  onBlur={(e) =>
                    setTicketsToAssign((prev) => {
                      prev[idx].googleWalletUrl = e.target.value;
                      return prev;
                    })
                  }
                />
                <Button
                  variant="default"
                  onClick={() => {
                    setTickets((prev: any[]) => [
                      ...prev.filter((pt) => pt.id !== t.id),
                      t,
                    ]);
                    setTicketsToAssign((prev) =>
                      prev.filter((pt) => pt.id !== t.id),
                    );
                    setOpen(false);
                  }}
                >
                  <PlusIcon /> Add Ticket
                </Button>
              </DialogContent>
            </Dialog>
          </TicketCard>
        );
      })}
    </div>
  );
}
